import { searchInsureds } from '../../../api/portal-api';
import { withSearchBlueprint } from '../../blueprints/search';

const INSUREDS_SET_COLUMNS = 'INSUREDS_SET_COLUMNS';

/* Actions
================================================== */
export const setInsuredsColumns = columns => dispatch => {
  dispatch({ type: INSUREDS_SET_COLUMNS, columns });
};

const DEFAULT_STATE = {
  columns: [],
  pageFilters: { insuredCompanyNameOrder: 'asc' }
};

const INSURED_LIST_INSURED_NAME_ORDER = 'INSURED_LIST_INSURED_NAME_ORDER';
export const setInsuredListInsuredNameOrder = order => dispatch => {
  dispatch({ type: INSURED_LIST_INSURED_NAME_ORDER, order });
};

const INSURED_LIST_CLEAR_FILTERS = 'INSURED_LIST_CLEAR_FILTERS';
export const clearInsuredListFilters = () => dispatch => {
  dispatch({ type: INSURED_LIST_CLEAR_FILTERS });
  dispatch(insuredListSearch.resetFilters());
  // dispatch(insuredListSearch.updateSortBy([{
  //   id: 'company_name',
  //   desc: DEFAULT_STATE.pageFilters.insuredCompanyNameOrder === 'desc'
  // }]));
};

const INSURED_LIST_UNMOUNT = 'INSURED_LIST_UNMOUNT';
export const unmountInsuredListSearch = () => dispatch => {
  dispatch({ type: INSURED_LIST_UNMOUNT });
  dispatch(insuredListSearch.clearSearch());
};

const insuredListReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case INSURED_LIST_INSURED_NAME_ORDER:
      return { ...state, pageFilters: { ...state.pageFilters, insuredCompanyNameOrder: action.order } };

    case INSURED_LIST_CLEAR_FILTERS: {
      return {
        ...state,
        pageFilters: { insuredCompanyNameOrder: 'asc' }
      };
    }

    case INSURED_LIST_UNMOUNT:
      return {
        ...state,
        pageFilters: { insuredCompanyNameOrder: 'asc' }
      };

    default:
      return state;
  }
};

export const { reducer, ...insuredListSearch } = withSearchBlueprint('insuredList', insuredListReducer, {
  endpoint: searchInsureds,
  defaultSort: [
    { id: 'insured', desc: false }
  ],
  globalSearchIndices: [
    'external_id^2',
    'insurance_requirements.job.name',
    'company_name',
    'email'
  ]
});

export const selectInsuredListFilters = state => state.insuredList.base.pageFilters;
